export const inputStyle = {
    width: "calc(100% - 46px)",
    borderStartEndRadius: "6px",
    borderEndEndRadius: "6px",
    marginRight: "4px",
    height: "40px",
};

export const buttonStyle = {
    height: "40px",
    width: "40px",
    borderRadius: "6px",
};
